/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ShippingOrderRequestItem } from './shippingOrderRequestItem';

export interface ShippingOrderRequestDetail {
  cnpj?: string;
  companyServiceName?: string;
  cpf?: number;
  dateCreated?: Date;
  dateSyncERP?: Date;
  email?: string;
  errorMessage?: string;
  glamId?: string;
  items?: Array<ShippingOrderRequestItem>;
  nfse?: string;
  nfseResend?: string;
  personId?: number;
  personName?: string;
  phone?: string;
  shippingCompanyId?: number;
  shippingCompanyName?: string;
  shippingOrderIdOriginal?: number;
  shippingOrderIdResend?: number;
  shippingOrderRequestId?: number;
  shippingOrderStatus?: number;
  shippingOrderStatusName?: string;
  shippingOrderStatusNameResend?: string;
  shippingOrderStatusResend?: number;
  shippingOrderTypeId?: number;
  shippingOrderTypeIdResend?: number;
  shippingOrderTypeName?: string;
  shippingOrderTypeNameResend?: string;
  shippingServiceId?: number;
  shippingServiceName?: string;
  status?: ShippingOrderRequestDetail.StatusEnum;
  statusMillennium?: string;
  subscriberEditionId?: number;
  theme?: string;
  ticketDetail?: string;
  ticketId?: string;
  ticketOrigin?: string;
  ticketShippingStatus?: string;
  ticketSubject?: string;
}
export namespace ShippingOrderRequestDetail {
  export type StatusEnum =
    | 'PENDENTE'
    | 'CRIADO'
    | 'ERRO'
    | 'CANCELADO'
    | 'PERSISTIDO';
  export const StatusEnum = {
    PENDENTE: 'PENDENTE' as StatusEnum,
    CRIADO: 'CRIADO' as StatusEnum,
    ERRO: 'ERRO' as StatusEnum,
    CANCELADO: 'CANCELADO' as StatusEnum,
    PERSISTIDO: 'PERSISTIDO' as StatusEnum
  };
}
